import React from 'react';
import ParallaxHeader from '../components/Parallaxheader';
import { reviews } from '../data/review';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';

const Reviews = () => {
  return (
    <>
      <ParallaxHeader
        title="Reviews"
        breadcrumbs={[{ title: 'Reviews', path: '/reviews' }]}
        backgroundImage="/images/aboutheader.jpg"
        overlayColor="rgba(0, 0, 0, 0.7)"
      />

      <section className="py-20 bg-gradient-to-b from-white to-[#f8f5ed] min-h-screen">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* Heading */}
          <div className="max-w-3xl mx-auto text-center mb-16">
            <div className="inline-block bg-amber-100 text-amber-800 px-4 py-1 rounded-full text-sm font-medium mb-4">
              Trusted by Parents
            </div>

            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 tracking-tight mb-6 font-serif">
              What Parents Say About Us
            </h1>

            <p className="text-xl text-gray-600">
              Real experiences from parents and students who are part of
              Thirumal Chess Academy.
            </p>
          </div>

          {/* Reviews Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {reviews.map((review, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.08 }}
                viewport={{ once: true }}
                className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300"
              >
                {/* Stars */}
                <div className="flex items-center mb-4">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-5 h-5 fill-amber-400 text-amber-400"
                    />
                  ))}
                </div>
                {/* Quote */}
                <p className="text-gray-700 leading-relaxed mb-6 italic">
                  "{review.quote}"
                </p>
                {/* User */}
                <div className="border-t border-gray-100 pt-4">
                  <h4 className="font-bold text-gray-900">
                    {review.name}
                  </h4>
                  <p className="text-sm text-gray-500">
                    {review.time}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Reviews;